const actIndex = resolve => {
  import('../views/act/index').then(actIndex => {
    resolve(actIndex)
  })
}
const actInfo = resolve => {
  import('../views/act/info').then(actInfo => {
    resolve(actInfo)
  })
}
const actList = resolve => {
  import('../views/act/actlist').then(actIndex => {
    resolve(actIndex)
  })
}
const spellInfo = resolve => {
  import('../views/act/spellinfo').then(spellInfo => {
    resolve(spellInfo)
  })
}
const actApply = resolve => {
  import('../views/act/apply').then(actApply => {
    resolve(actApply)
  })
}

export default [
  {
    path: '/wechat/act',
    name: 'act',
    component: actIndex,
    meta: {
      title: '活动中心',
      requireAuth: false,
      keepAlive: false,
      footer: true,
    }
  },
  {
    path: '/wechat/actinfo/:id',
    name: 'act',
    component: actInfo,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/spellinfo/:id',
    name: 'act',
    component: spellInfo,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/actlist/:actType',
    name: 'act',
    component: actList,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  },
  {
    path: '/wechat/act/:id/apply',
    name: 'act',
    component: actApply,
    meta: {
      requireAuth: false,
      keepAlive: false,
      footer: false,
    }
  }
]
